// extracted by mini-css-extract-plugin
export default {"cardHeader":"ReverseMortgageModule_cardHeader__Havag","cardBody":"ReverseMortgageModule_cardBody__heDCV","cardFooter":"ReverseMortgageModule_cardFooter__VwvQ4"};